import isPropValid from '@emotion/is-prop-valid';
import { ConfigProvider as ANTDThemeProvider, App } from 'antd';
import { useMemo } from 'react';
import {
  DefaultTheme,
  ThemeProvider as SCThemeProvider,
  StyleSheetManager,
  useTheme,
} from 'styled-components';

import { applyThemeForAntd } from './AntdThemeConfig/AntdThemeConfig';
import { ThemeCssVariables } from './ThemeCssVariables';

function shouldForwardProp(propName: string, target: unknown) {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }

  return true;
}

const DURATION_IN_SECS = 3;
const MAX_COUNT = 1;

export const ThemeProvider = ({
  children,
  theme,
  enableCssVariables = false,
}: {
  children: React.ReactNode;
  theme: DefaultTheme;
  enableCssVariables?: boolean;
}) => {
  const antdTheme = useMemo(() => {
    return applyThemeForAntd(theme);
  }, [theme]);

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
      <App
        component={false}
        message={{
          duration: DURATION_IN_SECS,
          maxCount: MAX_COUNT,
        }}
      >
        <ANTDThemeProvider theme={antdTheme}>
          <SCThemeProvider theme={theme}>
            {enableCssVariables && <ThemeCssVariables />}
            {children}
          </SCThemeProvider>
        </ANTDThemeProvider>
      </App>
    </StyleSheetManager>
  );
};

export { useTheme };
